// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__382lZ","buttons":"RemoveExpirationActionButtons_buttons__2ISxi"};